var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { connect } from 'react-redux';

import * as quizzActions from './../quizzActions';

import Answer from './../Answer/Answer';

export var Question = function (_Component) {
    _inherits(Question, _Component);

    function Question() {
        var _temp, _this, _ret;

        _classCallCheck(this, Question);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
            answers: {},
            touched: false // updated when user make a choice
        }, _this.handleSubmit = function (e) {
            e.preventDefault();
            var _this$props = _this.props,
                dispatch = _this$props.dispatch,
                quizz = _this$props.quizz;

            var currentQuizzId = _this.props.relatedToQuizzId;
            var currentStep = quizz.articleQuizzes[currentQuizzId].quizzStep;

            var userAnswers = _this.state.answers[currentQuizzId];
            if (!_this.state.touched) {
                userAnswers = [];
            }

            dispatch(quizzActions.checkResult(userAnswers, currentQuizzId, currentStep));
        }, _this.onChangehandler = function (e, index) {
            var quizz = _this.props.quizz;


            var currentQuizzId = _this.props.relatedToQuizzId;

            var questionType = quizz.articleQuizzes[currentQuizzId].quizzType;

            var allAnswers = _extends({}, _this.state.answers);
            var currentQuizzAnswers = _extends({}, allAnswers[currentQuizzId]); // immutable, we create a copy

            if (questionType === 'single') {

                for (var i in currentQuizzAnswers) {
                    currentQuizzAnswers[i] = false;
                }currentQuizzAnswers[index] = true;
            } else {
                currentQuizzAnswers[index] = !_this.state.answers[currentQuizzId][index];
            }

            allAnswers[currentQuizzId] = currentQuizzAnswers; // Caution mutable, we carefully mutate the state with a cloned copy created before

            _this.setState({ answers: allAnswers, touched: true });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    /* Can be removed
    constructor(props){
        super(props);
        this.onChangehandler = this.onChangehandler.bind(this);
    }*/

    Question.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        var currentQuizzId = props.relatedToQuizzId;
        if (currentQuizzId !== '' && props.quizz.articleQuizzes.hasOwnProperty(currentQuizzId)) {
            var questionData = props.quizz.articleQuizzes[currentQuizzId];
            var answers = questionData.quizzAnswers;
            var stateAnswersCount = 0;
            for (var i in state.answers[currentQuizzId]) {
                stateAnswersCount++;
            }
            //the answers.length pass to 0 when we validate the answer and then take the value when we get the next question
            if (answers.length !== stateAnswersCount) {
                var control = _extends({}, state.answers);
                control[currentQuizzId] = {};
                for (var _i = 0; _i < answers.length; _i++) {
                    control[currentQuizzId][_i] = false;
                }

                return { answers: control, touched: false };
            }

            return null;
        }
        return null;
    };

    Question.prototype.componentDidMount = function componentDidMount() {
        var _props = this.props,
            dispatch = _props.dispatch,
            quizz = _props.quizz;

        var currentQuizzId = this.props.relatedToQuizzId;

        //@deprecated : this call is done now through action reducer "getQuizzData"
        //dispatch(quizzActions.getQuestionData(currentQuizzId, quizz.articleQuizzes[currentQuizzId].quizzStep));

        // when user has already answered to the current quizz
        if (Object.keys(quizz.previousUserAnswers).length > 0 && quizz.previousUserAnswers.hasOwnProperty(currentQuizzId)) {
            // we dispatch a new action, so as to unlock the remaining part of article
            dispatch(quizzActions.completeStep(currentQuizzId));
        }
    };

    Question.prototype.render = function render() {
        var _this2 = this;

        var quizz = this.props.quizz;

        var currentQuizzId = this.props.relatedToQuizzId;
        var question = null;

        if (currentQuizzId !== '' && quizz.articleQuizzes.hasOwnProperty(currentQuizzId)) {
            var questionData = quizz.articleQuizzes[currentQuizzId];
            var counterQuestion = questionData.totalQuizzStep > 1 ? '[' + (questionData.quizzStep + 1) + '/' + questionData.totalQuizzStep + '] ' : '';

            if (Object.keys(questionData).length > 0) {
                question = React.createElement(
                    'div',
                    { className: 'quizz-container' },
                    React.createElement(
                        'span',
                        { className: 'question' },
                        counterQuestion,
                        questionData.quizzQuestion
                    ),
                    React.createElement(
                        'form',
                        { className: 'input', onSubmit: this.handleSubmit },
                        questionData.quizzAnswers.map(function (answer, index) {

                            var answersFound = false;
                            var isPreviouslyAnswered = false;
                            var isRightAnswer = false;

                            // when current quizz has been answered (case of page refresh for example), we look at the answer(s) stored
                            if (questionData.quizzUserAnswers.length > 0 && !questionData.showResult) {
                                //console.log('[Debug] get from user answser (quizzUserAnswers)', questionData);  

                                answersFound = true;
                                // when user has already answered to the current quizz
                                for (var i = 0; i < questionData.quizzUserAnswers.length; i++) {
                                    if (parseInt(questionData.quizzUserAnswers[i]) === index) {
                                        isPreviouslyAnswered = true;
                                        break;
                                    }
                                }

                                // check if the current choice is a correct answer
                                if (questionData.quizzGoodAnswers.length > 0) {
                                    for (var j = 0; j < questionData.quizzGoodAnswers.length; j++) {
                                        if (answer === questionData.quizzGoodAnswers[j]) {
                                            isRightAnswer = true;
                                            break;
                                        }
                                    }
                                }
                            }
                            // if the user has already answered to this quizz previously and data are retrieved from the history storage
                            else if (Object.keys(quizz.previousUserAnswers).length > 0 && !questionData.showResult) {
                                    // when user has already answered to the current quizz
                                    //console.log('[Debug] rebuild previous answer', quizz.previousUserAnswers);    

                                    var userAnswers = [];
                                    if (quizz.previousUserAnswers.hasOwnProperty(currentQuizzId)) {

                                        userAnswers = quizz.previousUserAnswers[currentQuizzId];

                                        if (userAnswers.length > 0) {
                                            answersFound = true;
                                        }

                                        for (var field in userAnswers) {
                                            if (userAnswers[field].hasOwnProperty('answer') && userAnswers[field].hasOwnProperty('valid')) {
                                                // check if the following answer has been chosen before
                                                if (parseInt(userAnswers[field].answer) === index) {
                                                    isPreviouslyAnswered = true;
                                                }
                                                // check the status's answer to determine if answer is right or wrong
                                                if (userAnswers[field].valid) {
                                                    isRightAnswer = true;
                                                    break;
                                                }
                                            }
                                        }
                                    }
                                }

                            return React.createElement(Answer, { key: index,
                                index: index,
                                quizzId: currentQuizzId,
                                answerText: answer,
                                type: questionData.quizzType,
                                alreadyAnswered: answersFound,
                                previouslyChosen: isPreviouslyAnswered,
                                correctlyAnswered: isRightAnswer,
                                onChangehandler: function onChangehandler(event) {
                                    return _this2.onChangehandler(event, index);
                                } });
                        }),
                        quizz.articleQuizzes.hasOwnProperty(currentQuizzId) && (quizz.articleQuizzes[currentQuizzId].quizzUserAnswers.length === 0 || quizz.articleQuizzes[currentQuizzId].quizzStep < quizz.articleQuizzes[currentQuizzId].totalQuizzStep) && !quizz.previousUserAnswers.hasOwnProperty(currentQuizzId) ? React.createElement('input', { type: 'submit', value: 'Valider' }) : React.createElement('input', { className: 'disabled', type: 'submit', disabled: 'true', value: 'D\xE9j\xE0 r\xE9pondu' })
                    )
                );
            }
        }
        return question;
    };

    return Question;
}(Component);;

var mapStateToProps = function mapStateToProps(state) {
    return {
        quizz: state.quizz
    };
};

export default connect(mapStateToProps)(Question);


//////////////////
// WEBPACK FOOTER
// ./node_modules/nm-react-quiz/es/components/Quizz/Question/Question.js
// module id = 231
// module chunks = 0